export * from "./lib/client-ui-loading-button.module";
